import React, { Component } from 'react';
import { Container, Grid, Segment, Header, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';

import {
    getElogConfigQuestions,
    submitElog2,
    getClaimOptionsElog
} from '../../actions';
import FormsElog from '../../component/forms/elog';

class SubmitElogPage extends Component {
    componentDidMount() {
        this.fetchElogOptions()
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.fetchElogOptions();
        }
    }

    fetchElogOptions() {
        const {accessToken} = this.props.user;
        const companyId = this.props.user.companies[0].companyId

        this.props.getElogConfigQuestions(this.props.user.nric, accessToken);
        this.props.getClaimOptionsElog(accessToken, companyId);
    }

    render() {
        if (!this.props.eLogQuestions) {
            return <Loader active />
        }
        return (
            <Container fluid>
                <Segment attached="top">
                    <Header>Request eLOG (Letter of Guarantee)</Header>
                </Segment>
                <Segment attached>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <FormsElog
                                    user={this.props.user}
                                    claimOptions={this.props.claimOptions}
                                    eLogQuestions={this.props.eLogQuestions}
                                    submitElog={this.props.submitElog2}
                                    getClaimOptions={this.props.getClaimOptionsElog}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        claimOptions: state.claimOptions,
        eLogQuestions: state.appConfig.eLogQuestions,
        contactNoVerified: state.otp.contactNoVerified,
    };
}

export default connect(mapStateToProps,{
    getElogConfigQuestions,
    submitElog2,
    getClaimOptionsElog
})(SubmitElogPage);
